<script lang="ts" setup>
const props = defineProps({
  linkTitle: String,
  icon: {
    type: String,
    default: 'icon-arrow-right3'
  }
})
</script>

<template>
  <nuxt-link class="link">
    <div class="link__icon">
      <svg-icon :name="props.icon" />
    </div>
    <div class="link__title" v-if="props.linkTitle">{{ props.linkTitle }}</div>
  </nuxt-link>
</template>

<style lang="scss" scoped>
.link {
  display: flex;
  align-items: center;
  margin-bottom: toRem(10);
  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: toRem(40);
    height: toRem(40);
    margin-right: toRem(12);
    border: 1px solid $color-gray-line;
    border-radius: 50%;
    color: $color-brand-3;
    svg {
      width: toRem(16);
      height: toRem(16);
    }
  }
  &__title {
    font-size: toRem(16);
    line-height: 1.45;
    color: $color-gray-1;
  }
  &.large {
    .link {
      &__icon {
        width: toRem(48);
        height: toRem(48);
        @include max-media(640) {
          width: toRem(32);
          height: toRem(32);
        }
        svg {
          width: toRem(24);
          height: toRem(24);
          @include max-media(640) {
            width: toRem(16);
            height: toRem(16);
          }
        }
      }
      &__title {
        font-size: toRem(20);
        @include max-media(640) {
          font-size: toRem(16);
        }
      }
    }
  }
  &.small {
    .link {
      &__icon {
        width: toRem(32);
        height: toRem(32);
        svg {
          width: toRem(16);
          height: toRem(16);
        }
      }
      &__title {
        font-size: toRem(16);
      }
    }
  }
  &.icon-brand-4 {
    .link {
      &__icon {
        color: $color-brand-4_1;
      }
    }
  }
  &.icon-gray-1 {
    .link {
      &__icon {
        color: $color-gray-1;
      }
    }
  }
}
</style>
